import { getRecordingApi } from '@fullstory/browser-api';
import { useFlags } from '@fullstory/react-hooks';
import { useEffect, useMemo } from 'react';
import { FeatureFlags } from '@fullstory/client-api';

/**
 * @deprecated use FsPageV2 instead
 */
export const FsPage = ({ pageName, properties }: { pageName?: string, properties?: { [name: string]: any } }) => {
  const api = getRecordingApi(window);
  api?.setVars('page', {
    ...(pageName ? { pageName } : {}),
    ...properties,
  });
};

export const FsPageV2 = ({ pageName, properties }: { pageName?: string, properties?: { [name: string]: any } }) => {
  const api = getRecordingApi(window);
  api?.('setProperties', {
    type: 'page',
    properties: {
      ...(pageName ? { pageName } : {}),
      ...properties,
    },
  });
};

export const useFsPageWithFlags = (): void => {
  const flags = useFlags();
  const properties = useMemo(() =>
  ({
    ...processLdFlagsForPageVars(flags?.featureFlags()),
    AppTheme: document.querySelector('html')?.getAttribute('data-theme'),
  }), [flags]);

  useEffect(() => {
    FsPageV2({ properties });
  }, [flags, properties]);
};


export function processLdFlagsForPageVars(flags: FeatureFlags | undefined): { [name: string]: any } {
  const toRet: { [name: string]: any } = {};
  const booleanFlags: string[] = [];
  if (!flags) {
    return toRet;
  }

  Object.entries(flags).forEach(([key, value]) => {
    if (isBool(value)) {
      if (value) {
        booleanFlags.push(key);
      }
    } else {
      toRet[key] = value;
    }
  });
  toRet.launchDarklyFlags = booleanFlags;
  return toRet;
}

function isBool(x: any): boolean {
  return typeof x == 'boolean';
}
